import { useRoute } from 'vue-router';

export default function useWidgetCheck() {
  const checkWidget = () => {
    const route = useRoute();
    return route?.name && route.name.includes('widget');
  };

  return {
    checkWidget,
  };
}
